export default "__VITE_ASSET__BDvJ94E7__"